import { BASE_URL } from 'config';
import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Avatar,
  Typography,
  FormControl,
  FormHelperText,
  Grid,
  Divider,
  Input,
  IconButton,
  InputLabel,
} from "@mui/material";
import SubmitButton from 'components/styled-component/ReusableButton';

import AddIcon from "@mui/icons-material/Add";
import { UploadFile } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { validateEmail, validateRequired, validatePasswordMatch } from "validations";
import axios from "axios";
import Swal from "sweetalert2";
import avatar from "assets/theme/components/avatar";
import { InsertInvitation } from "@mui/icons-material";
import { PrimaryColor } from "assets/theme/base/themeColors";
import { useMaterialUIController } from "context";
import { useTheme } from "@mui/material/styles";
const AddStoreDocumntationForm = ({ onClose, onSuccess, initialData }) => {
  const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();
  const [formData, setFormData] = useState({
    id: initialData?.id || null,
    store_id: initialData?.store_id || null,
    business_name: initialData?.business_name || "",
    commercial_registration_number: initialData?.commercial_registration_number || "",
    unified_number: initialData?.unified_number || "",
    cr_expiry_date: initialData?.cr_expiry_date
      ? initialData.cr_expiry_date.split(" ")[0]
      : "2000-01-01",
    municipal_license_number: initialData?.municipal_license_number || "",
    municipal_license_expiry: initialData?.municipal_license_expiry
      ? initialData.municipal_license_expiry.split(" ")[0]
      : "2000-01-01",
    status: initialData?.status || 1,
    owner_phone: initialData?.owner_phone || "",
    cr_file_url: initialData?.cr_file_url || null,
    license_file_url: initialData?.license_file_url || null,
    national_address_file_url: initialData?.national_address_file_url || null,
    tax_number: initialData?.tax_number || "",
    tax_file_url: initialData?.tax_file_url || null,
  });

  // Add useEffect to handle initial data
  useEffect(() => {
    if (initialData) {
      setFormData({
        id: initialData.id,
        store_id: initialData.store_id,
        business_name: initialData.business_name,
        commercial_registration_number: initialData.commercial_registration_number,
        unified_number: initialData.unified_number,
        cr_expiry_date: initialData.cr_expiry_date
          ? initialData.cr_expiry_date.split(" ")[0]
          : "2000-01-01",
        municipal_license_number: initialData.municipal_license_number,
        municipal_license_expiry: initialData.municipal_license_expiry
          ? initialData.municipal_license_expiry.split(" ")[0]
          : "2000-01-01",
        status: initialData.status,
        owner_phone: initialData.owner_phone,
        cr_file_url: initialData.cr_file_url,
        license_file_url: initialData.license_file_url,
        national_address_file_url: initialData.national_address_file_url,
        tax_number: initialData.tax_number,
        tax_file_url: initialData.tax_file_url,
      });
    }
  }, [initialData]);
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [stores, setStores] = useState([]);
  useEffect(() => {
    if (formSubmitted) validateForm();
  }, [formData]);
  useEffect(() => {
    const fetchStores = async () => {
      const token = localStorage.getItem("user-token");
      try {
        const response = await fetch(BASE_URL + "/administrator/stores", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        setStores(data.data);
      } catch (error) {
        console.error("Error fetching Stores:", error);
      }
    };
    fetchStores();
  }, []);
  const validateForm = () => {
    const newErrors = {};

    if (!validateRequired(formData.business_name))
      newErrors.business_name = "يرجى ادخال الاسم التجاري";
    if (!formData.store_id) newErrors.store_id = "يرجى اختيار اسم المتجر  ";
    if (!validateRequired(formData.commercial_registration_number))
      newErrors.commercial_registration_number = "يرجى ادخال رقم السجل التجاري";
    if (formData.cr_expiry_date == null)
      newErrors.cr_expiry_date = "يرجى ادخال تاريخ نهاية السجل التجاري";
    if (!validateRequired(formData.unified_number))
      newErrors.unified_number = "يرجى ادخال الرقم الموحد";
    if (!validateRequired(formData.owner_phone)) newErrors.owner_phone = "يرجى ادخال رقم  الجوال";
    if (!formData.cr_file_url) newErrors.cr_file_url = "يرجى ادخال صورة او ملف السجل التجاري";
    if (!formData.national_address_file_url)
      newErrors.national_address_file_url = "يرجى ادخال صورة او ملف العنوان الوطني";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name;
    if (!file) return;
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/gif",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (allowedTypes.includes(file.type)) {
      setFormData((prev) => ({ ...prev, [fieldName]: file }));
      setErrors((prev) => ({ ...prev, [fieldName]: "" }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [fieldName]: "الملف يجب أن يكون صورة أو PDF أو Word (doc, docx) فقط",
      }));
    }
  };

  const handleSubmit = async (e) => {
    console.log("the formdata: ", formData);
    e.preventDefault();
    setFormSubmitted(true);

    if (!validateForm()) return;

    try {
      const formPayload = new FormData();
      // Append all form data including files
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          // Handle avatar differently for existing vs new
          if (
            key === "cr_file_url" ||
            key === "license_file_url" ||
            key === "tax_file_url" ||
            key === "national_address_file_url"
          ) {
            // Only append new files, keep existing path if no new file
            if (value instanceof File) {
              formPayload.append(key, value);
            }
          } else {
            formPayload.append(key, value);
          }
        }
      });

      // Show loading indicator
      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
      console.log("Sending payload:", formPayload); // طباعة البيانات المرسلة
      const token = localStorage.getItem("user-token");
      console.log("the form id : ", formData.id);
      const endpoint = formData.id
        ? `${BASE_URL}/administrator/store-documents/update/${formData.id}`
        : BASE_URL + "/administrator/store-documents/store";

      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      // طباعة تفاصيل الرد
      console.log("Full Response:", response);
      console.log("Response Data:", response.data);
      console.log("Status Code:", response.status);
      // Close loading indicator
      Swal.close();

      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
        onSuccess();
        onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      console.error("Error Details:", error);
      console.log("Error Response:", error.response?.data);
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء  الحفظ";

      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setFormSubmitted(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
      phone: "",
      type: "",
      avatar: null,
    });
    setErrors({});
    onClose();
  };
  const handleRemoveImage = () => {
    setFormData((prev) => ({ ...prev, avatar: null }));
  };
  function getFileType(url) {
    // استخراج الامتداد من الرابط
    const extension = url.split(".").pop().toLowerCase();

    // تحديد نوع الملف بناءً على الامتداد
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
    const documentExtensions = ["pdf", "doc", "docx", "txt", "xls", "xlsx", "ppt", "pptx"];

    if (imageExtensions.includes(extension)) {
      return "Image";
    } else if (documentExtensions.includes(extension)) {
      return "Document";
    } else {
      return "Unknown";
    }
  }
  // Output: Document
  return (
    <Box
      sx={{
        p: 3,
        width: "100%",
        bgcolor: darkMode ? theme.palette.background.default : "background.paper",
        borderRadius: 2,
        boxShadow: 3,
        color: darkMode ? "white !important" : "inherit",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          {formData.id ? "تعديل الوثيقة" : "إضافة وثيقة جديدة"}
        </Typography>
      </Box>

      {/* Main Form */}
      <Box spacing={3}>
        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
          الوثائق الرسمية للمتجر
        </Typography>
        {/* Left Column */}
        <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
          <FormControl fullWidth error={!!errors.business_name} sx={{ mb: 2 }}>
            <TextField
              label="الاسم التجاري *"
              name="business_name"
              value={formData.business_name}
              onChange={handleChange}
              error={!!errors.business_name}
              helperText={errors.business_name}
            />
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id="store-label">اختر المتجر</InputLabel>
            <Select
              labelId="store-label"
              name="store_id"
              value={formData.store_id}
              onChange={handleChange}
              error={!!errors.store_id}
              helperText={errors.store_id}
              label="اختر المتجر"
              sx={{ height: 43, mb: 2 }}
            >
              {stores.map((store) => (
                <MenuItem key={store.id} value={store.id}>
                  {store.name_ar}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText error>{errors.store_id}</FormHelperText>
          </FormControl>

          <FormControl fullWidth error={!!errors.unified_number} sx={{ mb: 2 }}>
            <TextField
              label="الرقم الموحد*"
              name="unified_number"
              value={formData.unified_number}
              onChange={handleChange}
              error={!!errors.unified_number}
              helperText={errors.unified_number}
            />
          </FormControl>
        </Box>
        <Grid container spacing={2} display="flex" justifyContent="center" alignItems="center" gap={2}>
          <Grid item size={{ xs: 12, md: 4 }}>
            <FormControl fullWidth error={!!errors.commercial_registration_number} sx={{ mb: 2 }}>
              <TextField
                label="رقم السجل التجاري *"
                name="commercial_registration_number"
                value={formData.commercial_registration_number}
                onChange={handleChange}
                error={!!errors.commercial_registration_number}
                helperText={errors.commercial_registration_number}
              />
            </FormControl>
          </Grid>
          <Grid item size={{ xs: 12, md: 4 }}>


            <FormControl fullWidth error={!!errors.cr_expiry_date} sx={{ mb: 2 }}>
              <TextField
                label="تاريخ انتهاء السجل التجاري"
                type="date" // ✅ Make it a date picker
                name="cr_expiry_date"
                value={formData.cr_expiry_date}
                onChange={handleChange}
                error={!!errors.cr_expiry_date}
                helperText={errors.cr_expiry_date}
                InputLabelProps={{
                  shrink: true, // ✅ Important to show label correctly above the date
                }}
              />
            </FormControl>
          </Grid>
          <Grid item size={{ xs: 12, md: 4 }}>
            <Box gap={2}>
              <input
                type="file"
                id="upload-media"
                accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                style={{ display: "none" }}
                onChange={handleImageChange}
                name="cr_file_url"
              />
              <label htmlFor="upload-media">
                <Button
                  variant="contained"
                  component="span"
                  startIcon={<UploadFile />}
                  sx={{ px: 4, color: "white !important", background: PrimaryColor }}
                >
                  تحميل
                </Button>
              </label>

              <Typography variant="caption" color="textSecondary" display="block" mt={1}>
                صورة او ملف السجل التجاري
              </Typography>
              <FormHelperText error>{errors.cr_file_url}</FormHelperText>
            </Box>
          </Grid>
        </Grid>
        {formData.cr_file_url && (
          <>
            {typeof formData.cr_file_url === "string" ? (
              getFileType(formData.cr_file_url) === "Image" ? (
                <Avatar
                  variant="square"
                  src={formData.cr_file_url}
                  sx={{ width: 600, height: "100%", mt: 2, border: "2px solid #ddd" }}
                />
              ) : (
                <Box display="flex" alignItems="center" gap={1} mt={2}>
                  <InsertInvitation color="primary" />
                  <Typography variant="body2">{formData.cr_file_url.split("/").pop()}</Typography>
                  <a
                    href={formData.cr_file_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: 8 }}
                  >
                    معاينة / تحميل
                  </a>
                </Box>
              )
            ) : formData.cr_file_url.type && formData.cr_file_url.type.startsWith("image/") ? (
              <Avatar
                variant="square"
                src={URL.createObjectURL(formData.cr_file_url)}
                sx={{ width: 600, height: "100%", mt: 2, border: "2px solid #ddd" }}
              />
            ) : (
              <Box display="flex" alignItems="center" gap={1} mt={2}>
                <InsertInvitation color="primary" />
                <Typography variant="body2">{formData.cr_file_url.name || "ملف مرفق"}</Typography>
                <a
                  href={URL.createObjectURL(formData.cr_file_url)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: 8 }}
                >
                  معاينة / تحميل
                </a>
              </Box>
            )}
          </>
        )}
      </Box>
      <Grid container spacing={2} >
        <Grid item size={{ xs: 12, md: 4 }}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              label="رقم رخصة البلدية *"
              name="municipal_license_number"
              value={formData.municipal_license_number}
              onChange={handleChange}
            />
          </FormControl>
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              label="تاريخ انتهاء رخصة البلدية"
              type="date" // ✅ Make it a date picker
              name="municipal_license_expiry"
              value={formData.municipal_license_expiry}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true, // ✅ Important to show label correctly above the date
              }}
            />
          </FormControl>
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }}>
          <Box gap={2}>
            <input
              type="file"
              id="upload-media-license_file_url"
              accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              style={{ display: "none" }}
              onChange={handleImageChange}
              name="license_file_url"
              sx={{ mb: 2 }}
            />
            <label htmlFor="upload-media-license_file_url">
              <Button
                variant="contained"
                component="span"
                startIcon={<UploadFile />}
                sx={{ px: 4, color: "white !important", background: PrimaryColor }}
              >
                تحميل
              </Button>
            </label>
            <Typography variant="caption" color="textSecondary" display="block" mt={1}>
              صورة او ملف رخصة البلدية
            </Typography>
            <FormHelperText error>{errors.license_file_url}</FormHelperText>
          </Box>
        </Grid>
      </Grid>
      {formData.license_file_url && (
        <>
          {typeof formData.license_file_url === "string" ? (
            getFileType(formData.license_file_url) === "Image" ? (
              <Avatar
                variant="square"
                src={formData.license_file_url}
                sx={{ width: 600, height: "100%", mt: 2, border: "2px solid #ddd" }}
              />
            ) : (
              <Box display="flex" alignItems="center" gap={1} mt={2}>
                <InsertInvitation color="primary" />
                <Typography variant="body2">
                  {formData.license_file_url.split("/").pop()}
                </Typography>
                <a
                  href={formData.license_file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: 8 }}
                >
                  معاينة / تحميل
                </a>
              </Box>
            )
          ) : formData.license_file_url.type &&
            formData.license_file_url.type.startsWith("image/") ? (
            <Avatar
              variant="square"
              src={URL.createObjectURL(formData.license_file_url)}
              sx={{ width: 600, height: "100%", mt: 2, border: "2px solid #ddd" }}
            />
          ) : (
            <Box display="flex" alignItems="center" gap={1} mt={2}>
              <InsertInvitation color="primary" />
              <Typography variant="body2">
                {formData.license_file_url.name || "ملف مرفق"}
              </Typography>
              <a
                href={URL.createObjectURL(formData.license_file_url)}
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginLeft: 8 }}
              >
                معاينة / تحميل
              </a>
            </Box>
          )}
        </>
      )}
      <Grid container spacing={2} >
        <Grid item size={{ xs: 12, md: 4 }}>
          <FormControl fullWidth error={!!errors.owner_phone} sx={{ mb: 2 }}>
            <TextField
              label="رقم الهاتف*"
              name="owner_phone"
              value={formData.owner_phone}
              onChange={handleChange}
              error={!!errors.owner_phone}
              helperText={errors.owner_phone}
            />
          </FormControl>
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              label="الرقم الضريبي*"
              name="tax_number"
              value={formData.tax_number}
              onChange={handleChange}
            />
          </FormControl>
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }} display="flex" gap={2}>
          <Box gap={2}>
            <input
              type="file"
              id="upload-media-tax-number"
              accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              style={{ display: "none" }}
              onChange={handleImageChange}
              name="tax_file_url"
              sx={{ mb: 2 }}
            />
            <label htmlFor="upload-media-tax-number">
              <Button
                variant="contained"
                component="span"
                startIcon={<UploadFile />}
                sx={{ px: 4, color: "white !important", background: PrimaryColor }}
              >
                تحميل
              </Button>
            </label>
            <Typography variant="caption" color="text.border" display="block" mt={1}>
              صورة او ملف الرقم الضريبي
            </Typography>
          </Box>
          <Box gap={2}>
            <input
              type="file"
              id="upload-media-national_address_file_url"
              accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              style={{ display: "none" }}
              onChange={handleImageChange}
              name="national_address_file_url"
              sx={{ mb: 2 }}
            />
            <label htmlFor="upload-media-national_address_file_url">
              <Button
                variant="contained"
                component="span"
                startIcon={<UploadFile />}
                sx={{ px: 4, color: "white !important", background: PrimaryColor }}
              >
                تحميل
              </Button>
            </label>
            <Typography variant="caption" color="text.border" display="block" mt={1}>
              صورة او ملف العنوان الوطني
            </Typography>
            <FormHelperText error>{errors.national_address_file_url}</FormHelperText>
          </Box>
        </Grid>
      </Grid>
      <Box display="flex" alignItems="center" justifyContent="center" gap={2}>
        {formData.tax_file_url && (
          <>
            {typeof formData.tax_file_url === "string" ? (
              getFileType(formData.tax_file_url) === "Image" ? (
                <Avatar
                  variant="square"
                  src={formData.tax_file_url}
                  sx={{ width: 500, height: "100%", mt: 2, border: "2px solid #ddd" }}
                />
              ) : (
                <Box display="flex" alignItems="center" gap={1} mt={2}>
                  <InsertInvitation color="primary" />
                  <Typography variant="body2">{formData.tax_file_url.split("/").pop()}</Typography>
                  <a
                    href={formData.tax_file_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: 8 }}
                  >
                    معاينة / تحميل
                  </a>
                </Box>
              )
            ) : formData.tax_file_url.type && formData.tax_file_url.type.startsWith("image/") ? (
              <Avatar
                variant="square"
                src={URL.createObjectURL(formData.tax_file_url)}
                sx={{ width: 500, height: "100%", mt: 2, border: "2px solid #ddd" }}
              />
            ) : (
              <Box display="flex" alignItems="center" gap={1} mt={2}>
                <InsertInvitation color="primary" />
                <Typography variant="body2">{formData.tax_file_url.name || "ملف مرفق"}</Typography>
                <a
                  href={URL.createObjectURL(formData.tax_file_url)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: 8 }}
                >
                  معاينة / تحميل
                </a>
              </Box>
            )}
          </>
        )}
        {formData.national_address_file_url && (
          <>
            {typeof formData.national_address_file_url === "string" ? (
              getFileType(formData.national_address_file_url) === "Image" ? (
                <Avatar
                  variant="square"
                  src={formData.national_address_file_url}
                  sx={{ width: 500, height: "100%", mt: 2, border: "2px solid #ddd" }}
                />
              ) : (
                <Box display="flex" alignItems="center" gap={1} mt={2}>
                  <InsertInvitation color="primary" />
                  <Typography variant="body2">
                    {formData.national_address_file_url.split("/").pop()}
                  </Typography>
                  <a
                    href={formData.national_address_file_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: 8 }}
                  >
                    معاينة / تحميل
                  </a>
                </Box>
              )
            ) : formData.national_address_file_url.type &&
              formData.national_address_file_url.type.startsWith("image/") ? (
              <Avatar
                variant="square"
                src={URL.createObjectURL(formData.national_address_file_url)}
                sx={{ width: 500, height: "100%", mt: 2, border: "2px solid #ddd" }}
              />
            ) : (
              <Box display="flex" alignItems="center" gap={1} mt={2}>
                <InsertInvitation color="primary" />
                <Typography variant="body2">
                  {formData.national_address_file_url.name || "ملف مرفق"}
                </Typography>
                <a
                  href={URL.createObjectURL(formData.national_address_file_url)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: 8 }}
                >
                  معاينة / تحميل
                </a>
              </Box>
            )}
          </>
        )}
      </Box>
      {/* Actions Section */}
      <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="text.main">
          * الحقول المطلوبة
        </Typography>

        <Box display="flex" gap={2}>
          <Button variant="outlined" color="text" onClick={handleCancel} sx={{ px: 4, color: "text.main", borderColor: "text.border" }}>
            إلغاء
          </Button>
          <SubmitButton

            variant="primary"


            onClick={handleSubmit}
          >
            حفظ
          </SubmitButton>
        </Box>
      </Box>
    </Box>
  );
};

export default AddStoreDocumntationForm;
